import { useState } from "react";
import { Divider } from "antd";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import media from "../../../media";

const AuditDetails = ({
  auditFormInput,
  fatalNotFatalInfo,
  timeStampsDetails,
  qualityScore,
  auditorProfileImage,
  agentProfileImage,
}) => {
  const auditDetailsFormInput = auditFormInput && auditFormInput;
  const [isAuditorImgBroken, setIsAuditorImgBroken] = useState(false);
  const [isAgentImgBroken, setIsAgentImgBroken] = useState(false);
  return (
    <>
      <h3>Audit Details</h3>
      {auditDetailsFormInput &&
        Object.entries(auditDetailsFormInput).map(([key, item], i) => (
          <div
            className="align-items-center d-flex justify-content-between mt-4"
            key={i}
          >
            {key === "Reason for duplicate Transaction ID" &&
            item?.value === "" ? (
              <></>
            ) : (
              <>
                <span className="audit-details-left color-grey cusAuditCol">
                  {item?.icon && <img src={media[item.icon]?.svg} alt="icon" />}
                  <span>
                    {key && key.charAt(0)?.toUpperCase() + key.slice(1)}
                  </span>
                </span>
                <span className="cusAuditCol">
                  {key === "Stage" ? (
                    <img
                      src={
                        item?.value === "Audit Completed"
                          ? "../audited.PNG"
                          : item?.value === "Audit Pending"
                            ? "../pending.png"
                            : item?.value === "Accepted"
                              ? "../completed.png"
                              : "../disputed.png"
                      }
                      style={{ width: "17px" }}
                      alt="logo"
                    />
                  ) : key === "Auditor" ? (
                    <img
                      className="auditProfileImage"
                      src={
                        !isAuditorImgBroken &&
                        auditorProfileImage?.profilePicUrl
                          ? auditorProfileImage?.profilePicUrl
                          : process.env.REACT_APP_BACKEND + "/images/dummy.jpg"
                      }
                      alt={auditorProfileImage?.name}
                      onError={() => setIsAuditorImgBroken(true)}
                    />
                  ) : key === "agent" ? (
                    <img
                      className="auditProfileImage"
                      src={
                        !isAgentImgBroken && agentProfileImage?.profilePicUrl
                          ? agentProfileImage?.profilePicUrl
                          : process.env.REACT_APP_BACKEND + "/images/dummy.jpg"
                      }
                      alt={agentProfileImage?.name}
                      onError={() => setIsAgentImgBroken(true)}
                    />
                  ) : (
                    ""
                  )}

                  <span className="audit-details-left">
                    {key === "Audit Score"
                      ? secureLocalStorage.getItem("auditScore")
                        ? secureLocalStorage.getItem("auditScore") + "%"
                        : qualityScore + "%"
                      : key === "Transaction Date"
                        ? moment(item?.value).format("DD-MM-YY")
                        : key === "Audit Date and Time"
                          ? moment(item?.value).format("DD-MM-YY HH:MM A")
                          : item?.value &&
                            item?.value?.charAt(0)?.toUpperCase() +
                              item?.value.slice(1)}
                  </span>
                </span>
              </>
            )}
          </div>
        ))}

      {fatalNotFatalInfo &&
        Object.entries(fatalNotFatalInfo).map(([key, value], i) => {
          const label = key === "notFatal" ? "Not Fatal" : "Fatal";

          // Decide icon based on key (text)
          const iconName = key === "notFatal" ? "auditNoFatel" : "auditFatel";

          return (
            <div
              className="align-items-center d-flex justify-content-between mt-4"
              key={i}
            >
              {/* Left side: Icon + Text */}
              <span className="text11 audit-details-left color-grey d-flex align-items-center cusAuditCol">
                <img
                  src={media[iconName]?.svg}
                  alt={label}
                  className="auditIcon"
                />
                <span>{label}</span>
              </span>

              {/* Right side: Value */}
              <span className="text11 audit-details-right cusAuditCol">
                {value?.value ?? "-"}
              </span>
            </div>
          );
        })}

      <Divider />
      {timeStampsDetails && (
        <span className="audit-details-left">Time Stamps</span>
      )}
      {timeStampsDetails &&
        Object.entries(timeStampsDetails).map(([key, value], i) =>
          value !== null ? (
            <div
              className="align-items-center d-flex justify-content-between mt-4"
              key={i}
            >
              <span className="audit-details-left color-grey cusAuditCol">
                <img src={media.auditCalendar.svg} />{" "}
                {key &&
                  key.charAt(0).toUpperCase() + key.slice(1).replace("A", " A")}
              </span>
              <span className="cusAuditCol">
                <span className="audit-details-left">
                  {moment(value).format("DD-MM-YY HH:mm A")}
                </span>
              </span>
            </div>
          ) : (
            ""
          ),
        )}
    </>
  );
};

export default AuditDetails;
